module.exports = "<div class=home-container> <user-home ng-if=$ctrl.showUserHome></user-home> <login-home ng-if=$ctrl.showLoginHome></login-home> <holding-home ng-if=$ctrl.showHoldingHome></holding-home> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/home/home.html
// module id = 390
// module chunks = 0